module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.errorObj.type == 'pop') ? _c('section', {
    staticClass: "popup Pop"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "cell"
  }, [_c('span', {
    staticClass: "con"
  }, [_c('span', {
    staticClass: "info"
  }, [_vm._v(_vm._s(_vm.errorObj.errorMsg))])])])])]) : _vm._e(), _vm._v(" "), (_vm.errorObj.type == 'confirm') ? _c('section', {
    staticClass: "popup Confirm"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "cell"
  }, [_c('span', {
    staticClass: "con"
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "info"
  }, [_vm._v(_vm._s(_vm.errorObj.errorMsg))]), _vm._v(" "), _c('a', {
    staticClass: "btn cancel",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.confirmClick(false)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('a', {
    staticClass: "btn ok",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.confirmClick(true)
      }
    }
  }, [_vm._v("取消关注")])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "title",
    staticStyle: {
      "display": "block"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("温馨提示")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-490f06b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup.vue
// module id = 219
// module chunks = 3